module.exports = __webpack_public_path__ + "static/media/RoadMap_elImage2_482726.1404c1f2.jpg";